<template>
  <div class="table-tdrow" v-if="data">
    <div
      v-for="header in headers"
      class="table-td"
      :key="header.id"
      :class="header.class"
    >{{data[header.column]}}</div>
  </div>
</template>
<script>
export default {
  props: ['headers', 'data'],
};
</script>
